import axios from "axios";

const serverURL = process.env.REACT_APP_URL;

/**
 * Validates a file against optional type/size constraints.
 * Returns an error string, or null if the file is valid.
 */
export const validateMediaFile = (
  file,
  { allowedTypes, allowedTypePrefix, maxSizeMB } = {},
) => {
  if (allowedTypes && !allowedTypes.includes(file.type)) {
    return `Only ${allowedTypes.join(", ")} files are allowed.`;
  }
  if (allowedTypePrefix && !file.type.startsWith(allowedTypePrefix)) {
    return `Please select a ${allowedTypePrefix.replace("/", "")} file.`;
  }
  if (maxSizeMB && file.size > maxSizeMB * 1024 * 1024) {
    return `File size should not exceed ${maxSizeMB}MB.`;
  }
  return null;
};

export const uploadMediaFile = async (file) => {
  const formData = new FormData();
  formData.append("files", file);

  const response = await axios.post(`${serverURL}/upload`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  });

  if (!response?.data?.success) {
    throw new Error(response?.data?.message || "Upload failed.");
  }

  return response?.data?.data?.[0];
};
